@if (bundles.length > 0) {
  <mat-card>
    <mat-card-header>
      <span class="flex-container-space-between">
        <mat-card-title>{{ 'orders.belongsToBundles' | transloco }}</mat-card-title>
        <lib-disclosure-indicator [isExpanded]="!collapsed" color="white"
        (click)="onCollapse()"></lib-disclosure-indicator>
      </span>
    </mat-card-header>
    <mat-card-content>
      <div [@slideDown]="collapsed ? 'hidden' : 'visible'">
        <table mat-table [dataSource]="bundles" class="mat-elevation-z0">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.name' | transloco }} </th>
            <td mat-cell *matCellDef="let bundle"> {{bundle.name}} </td>
          </ng-container>
          <ng-container matColumnDef="navigate">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let bundle">
              <button mat-icon-button color="accent" (click)="navigateToBunde(bundle.id)"
                [attr.aria-label]="'orders.viewBundle' | transloco">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let bundle">
              <button mat-icon-button color="accent" (click)="deleteBundleOrderGroupConfirmation(bundle.id)"
                [attr.aria-label]="'orders.deleteBundle' | transloco">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
}